<div *ngIf="isPageReady && budgetWrappers" class="flex flex-col w-full h-full">
  <div class="qb-list-actions">
    <p-button [disabled]="isReadOnly" (onClick)="onBudgetAdd()" size="small" [label]="addLabel" icon="pi pi-plus"></p-button>
    <span class="qb-status-message">{{ statusMessage() }}</span>
  </div>
  <div class="qb-layout-grid">
    <prox-ag-grid [gridOptions]="budgetGridOptions" [rowData]="budgetWrappers"></prox-ag-grid>
  </div>
</div>